export default __webpack_public_path__ + "static/media/ic-check-circle.7fa5dbb9.svg";